module.exports = __webpack_public_path__ + "static/img/intoroduction_logo.091ff55.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/intoroduction_logo.png
// module id = 561
// module chunks = 1